import React from 'react';

import { LocaleContext } from '@/hooks/useTranslator';
import { Locale } from '@/types/locale';
import { formatAmount } from '@/utility/formatAmount';

export interface CustomFormatter {
  format(value: number | null, currency: string): string;
}

export const useCurrencyFormatter = (): CustomFormatter => {
  const locale = React.useContext<Locale>(LocaleContext);

  return {
    format: (value: number | null, currency: string): string => {
      return formatAmount(locale, value, currency);
    },
  };
};
